import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, distinctUntilChanged } from "rxjs";
import { LogLevel } from "src/app/enums/log/log-level.enum";
import { environment } from "src/environments/environment";


@Injectable({ providedIn: 'root' })
export class LoggingSettingsService {
  private readonly defaultLevel: LogLevel = (environment.defaultLoggingLevel ?? LogLevel.ERROR) as LogLevel;

  private readonly levelSubject = new BehaviorSubject<LogLevel>(this.defaultLevel);
  readonly level$: Observable<LogLevel> = this.levelSubject.asObservable().pipe(distinctUntilChanged());
  get level(): LogLevel { return this.levelSubject.value; }

  constructor() {}

  setLevel(level: LogLevel): void {
    if (this.levelSubject.value === level) return;
    this.levelSubject.next(level);
  }

  reset(): void {
    this.setLevel(this.defaultLevel);
  }
}
